import { render, staticRenderFns } from "./cgwReview.vue?vue&type=template&id=42a7698e&scoped=true&"
import script from "./cgwReview.vue?vue&type=script&lang=js&"
export * from "./cgwReview.vue?vue&type=script&lang=js&"
import style0 from "./cgwReview.vue?vue&type=style&index=0&id=42a7698e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a7698e",
  null
  
)

export default component.exports